export const RefundReasons = {
  en: {
    'Refund Reasons': 'Refund Reasons',
    'Create Refund Reason': 'Create Refund Reason',
  },
  uk: {
    'Refund Reasons': 'Причини повернення',
    'Create Refund Reason': 'Створити причину повернення',
  },
};

export const RefundReasonForm = {
  en: {
    ...RefundReasons.en,
    'New Refund Reason': 'New Refund Reason',
    'Edit Refund Reason': 'Edit Refund Reason',
    'Update Refund Reason': 'Update Refund Reason',
  },
  uk: {
    ...RefundReasons.uk,
    'New Refund Reason': 'Нова причина повернення',
    'Edit Refund Reason': 'Редагування причини повернення',
    'Update Refund Reason': 'Оновити причину повернення',
  },
};
